const tweet = (config={}) => {
  const { text='', url='', target="_blank" } = config
  const href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text + ' ' + url)}`
  window.open(href, target)
}

// https://www.websiteplanet.com/webtools/sharelink/
const fbshare = (config={}) => {
  const { text, url, target="_blank" } = config
  const href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
  window.open(href, target)
}

const lishare = (config={}) => {
  const { text, url, target="_blank" } = config
  const href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
  window.open(href, target)
}

const telegram = (config={}) => {
  const { text, url, target="_blank" } = config
  const href = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`
  window.open(href, target)
}

const whatsapp = (config={}) => {
  const { text, url, target="_blank" } = config
  const href = `https://api.whatsapp.com/send?text=${encodeURIComponent(text + ' ' + url)}`
  window.open(href, target)
}


const ShareMenu = function() {
  return {
    view: (vnode) => {
      const { share } = vnode.attrs
      return share && m("ons-speed-dial[position='bottom right'][direction='up']", [
        m("ons-fab", m("ons-icon[icon='md-share']")),
        m("ons-speed-dial-item", {
          onclick: () => tweet(share)
        }, m("ons-icon[icon='md-twitter']")),
        m("ons-speed-dial-item", {
          onclick: () => telegram(share)
        }, m("ons-icon[icon='fa-telegram']")),
        m("ons-speed-dial-item", {
          onclick: () => whatsapp(share)
        }, m("ons-icon[icon='fa-whatsapp']")),
        m("ons-speed-dial-item", {
          onclick: () => fbshare(share)
        }, m("ons-icon[icon='md-facebook']")),
        m("ons-speed-dial-item", {
          onclick: () => lishare(share)
        }, m("ons-icon[icon='md-linkedin']")),
        // m("ons-speed-dial-item",
        //   m("ons-icon[icon='md-email']")
        // ),
      ]
      )
    }
  }
}

export default ShareMenu



/*
var isObj = function(a) {
  if ((!!a) && (a.constructor === Object)) {
    return true;
  }
  return false;
};
var _st = function(z, g) {
  return "" + (g != "" ? "[" : "") + z + (g != "" ? "]" : "");
};
var fromObject = function(params, skipobjects, prefix) {
  if (skipobjects === void 0) {
    skipobjects = false;
  }
  if (prefix === void 0) {
    prefix = "";
  }
  var result = "";
  if (typeof(params) != "object") {
    return prefix + "=" + encodeURIComponent(params) + "&";
  }
  for (var param in params) {
    var c = "" + prefix + _st(param, prefix);
    if (isObj(params[param]) && !skipobjects) {
      result += fromObject(params[param], false, "" + c);
    } else if (Array.isArray(params[param]) && !skipobjects) {
      params[param].forEach(function(item, ind) {
        result += fromObject(item, false, c + "[" + ind + "]");
      });
    } else {
      result += c + "=" + encodeURIComponent(params[param]) + "&";
    }
  }
  return result;
};

console.log(fromObject({
  title: 'hi there',
  metaname: {
    'twitter:card': 'summary_large_image',
    'twitter:site': '@nytimes',
    'twitter:creator': '@SarahMaslinNir',
    'twitter:title': 'Parade of Fans for Houston’s Funeral',
    'twitter:description': 'NEWARK - The guest list and ',
    'twitter:image': 'http://graphics8.nytimes.com/images/2012/02/19/us/19whitney-span/19whitney-span-articleLarge.jpg',
  },

  metaprop: {
    'og:url': 'http://www.nytimes.com/2015/02/19/arts/international/when-great-minds-dont-think-alike.html',
    'og:type': 'website',
    'og:title': 'Parade of Fans for Houston’s Funeral',
    'og:description': 'NEWARK - The guest list and',
    'og:image': 'http://graphics8.nytimes.com/images/2012/02/19/us/19whitney-span/19whitney-span-articleLarge.jpg',
  }
}))
*/
